module.exports = __webpack_public_path__ + "static/media/aspera.822cbe3c.svg";